import { gql } from '@apollo/client/core';

const ADVENTURES_LIST_FRAGMENT = gql`
  fragment AdventuresList on Sitter {
    adventures {
      totalCount
      edges {
        node {
          adventure {
            id
            title
            status
            adventureCategoryName
            ageRangeText
            adventureCategoryImage {
              url
            }
          }
        }
      }
    }
  }
`;

export default ADVENTURES_LIST_FRAGMENT;
